import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tabs from "../../../components/tabs";
import TabPanel from "../../../components/tabs/tabpanel";
import Medium from "./medium";
import Novice from "./novice";
import PendingApprovals from "./pendingapprovals";
import UnverifiedEmails from "./unverifiedemails";
import Professional from "./professional";
import { useLocation } from 'react-router-dom';
import {
  getCountry,
  getLanguages,
  getTimezones,
} from "../../../services/uidata";

import {
  filterVisibleTimeZones
} from "../../../utils/helpers";
// import Pagination from "../../../components/tablePagination";

import {
  setAllMediums,
  setAllProfessionals,
  setAllIntermediate,
  setAllNovice,
  setUsers,
  setAllUnverifiedEmails,
  setAllDeclined,
  setDashboardCount,
  setAllMediumsCount,
  setAllMediumsCountPage,
  setAllDeclinedCount,
  
  setAllNoviceCount,
   setAllNoviceCountPage,
  setAllProfessionalsCount,
  setAllProfessionalsCountPage,
  setAllIntermediateCount,
  setAllIntermediateCountPage,
  setAllPendingApprovalsCount,
  setAllPendingApprovalsCountPage,
  setAllUnverifiedEmailsCount,
  setAllUnverifiedEmailsCountMediumPage,
  setMediumrowsPerPage,
  setMediumPage,
  setNovicePage,
  setNovicerowsPerPage,
  setIntermediatePage,
  setIntermediaterowsPerPage,
  setProfessionalPage,
  setProfessionalrowsPerPage,
  setPendingApprovalsPage,
  setPendingApprovalsrowsPerPage,
  setUnverifiedEmailsPage,
  setUnverifiedEmailsrowsPerPage,
  setDeclinedPage,
  setDeclinedrowsPerPage
} from "../../../reducer/adminSlice";

//service
import {
  getAllMediums,
  getAllProfessionals,
  getAllIntermediate,
  getAllDeclinedMediums,
  getAllNovice,
  getUsers,
  approveUser,
  filterAllmediums,
  filterAllNovice,
  filterAllIntermediate,
  filterAllProfessionals,
  performBulkActions,
  getAdminAppointmentCount,
  resendActivationMail,
  resendActivationUnverifiedMail,
  filterAllPendingApprovals,
  filterAllUnverifiedEmails,
  getUnverfiedEmailsMediums
} from "../../../services/admin";

import {
  list,
  filterList,
  filterListpendin,
  pendingApprovalFilterOptions,
  bulkList,
  bulkListDeclined,
} from "./data";
import Search from "../../../components/search";
import Button from "../../../components/button";
import Filter from "../../../components/filter";
import CsvDownload from "../../../components/csvdownload";
import { exportMediumList, regenerateAllMediumSlots } from "../../../services/admin";

import "./mediums.css";
import Intermediate from "./intermediate";
import { useSearchParams } from "react-router-dom";
import ConfirmDelete from "../Subcomponents/deleteconfirm";
import { setLoading } from "../../../reducer/auth/auth";
import Declined from "./declined";
import { toast } from "react-toastify";
import { set } from "date-fns";

export default function Mediums() {
  const {
    users,
    allMediums,
    allProfessionals,
    allNovice,
    allIntermediate,
    allDeclined,
    allunverifiedEmails,
    selectedTab,
    allMediumCount,
    allProfessionalsCount,
    allNoviceCount,
    allIntermediateCount,
    allDeclinedCount,
    allPendingApprovalsCount,
    allUnverifiedEmailsCount,
    mediumpage,
    mediumrowsPerPage,
    novicepage,
    novicerowsPerPage,
    intermediatePage,
    intermediaterowsPerPage,
    professionalPage,
    professionalrowsPerPage,
    pendingapprovalsPage,
    pendingapprovalsrowsPerPage,
    unverifiedEmailsPage,
    unverifiedEmailsrowsPerPage,
    declinedPage,
    declinedrowsPerPage,
    globalRowsPerPage

  } = useSelector((state) => state.users);

  const dispatch = useDispatch();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const status = searchParams.get("view");
  const searchVal = searchParams.get("search");
  const searchName = searchParams.get("searchName");
  const searchFilterOprater = searchParams.get("searchFilterOprater");
  const searchOprator = searchParams.get("searchOprator");
  const page = searchParams.get('page');
  const rowperpage = searchParams.get('rowperpage');
  const pagintion = searchParams.get('pagintion');


  const [listArray, setListArray] = useState(list);
  const [mediums, setMediums] = useState([]);
  const [professionals, setProfessionals] = useState([]);
  const [intermediate, setIntermediate] = useState([]);
  const [novice, setNovice] = useState([]);
  const [pendingApprovals, setPendingApprovals] = useState([]);
  const [unverifiedEmails, setUnverifiedEmails] = useState([]);
  const [declinedMediums, setDeclinedMediums] = useState([]);
  const [deleteInfo, setDeletInfo] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [isRecalculating, setIsRecalculating] = useState(false);
  const [backupmediums, setbackupMediums] = useState([]);
  const [backupprofessionals, setbackupProfessionals] = useState([]);
  const [backupPending, setbackupPending] = useState([]);
  const [backupUnverfiedEmails, setbackupUnverifiedEmails] = useState([]);
  const [backupintermediate, setbackupIntermediate] = useState([]);
  const [backupDeclined, setbackupDeclined] = useState([]);
  // const [mediumdata,setmediumdata]=useState({page:1,rowsPerPage:10});
  const [backupnovice, setbackupNovice] = useState([]);
  const [bulkInfo, setBulkInfo] = useState({});

  // Lifted from tab components so the filter section can live above the tabs
  const [selected, setSelected] = useState([]);
  const [checked, setChecked] = useState(false);

  const [filterValues, setFilterValues] = useState('screen_name');
  const [searchValue, setSearchValues] = useState('');
  const [queryValue, setQueryValue] = useState('');
  const queryParams = new URLSearchParams(location.search);

  const [operatorList, setOperatorList] = useState(['=', 'LIKE']);
  const [optionsList, setOptionsList] = useState([{ value: '1', name: 'Yes' },
  { value: '0', name: 'No' }]);
  const [filterValueOptions, setFilterValueOptions] = useState("");
  const [showOprater, setShowOprater] = useState(true);
  const [filterOprater, setFilterOprater] = useState("LIKE");

  const [countryData, setCountryData] = useState([]);
  const [TimezoneData, setTimezoneData] = useState([]);
  const [formLanguages, setFormLanguages] = useState([]);
  const [ShortingBy, setshortingBy] = useState("asc");
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    let data1 = {
      page: 1,
      rowsPerPage: 25,
    };
    if (!localStorage.getItem('pagination')) {
      console.log('working');
      localStorage.setItem('pagination', JSON.stringify(data1))
    }
    else {

    }
    // localStorage.setItem('pagintionTYPE', pagintion)

    if (searchVal !== null) {
      setFilterValues(searchVal);
    }
    setOptionsList([{ value: '1', name: 'Yes' },
    { value: '0', name: 'No' }]);
    if (searchName !== null) {
      setSearchValues({ [searchVal]: searchName })
      if (searchVal == "screen_name" || searchVal == "legal_name" || searchVal == "email") {
        setOperatorList(['=', 'LIKE']);

      } else if (searchVal == "id" || searchVal == "referralCode") {
        setOperatorList(['=',]);

      } else if (searchVal == "phone" || searchVal == "whatsapp") {
        setOperatorList(['=', 'LIKE']);

      } else if (searchVal == "created_at") {
        setOperatorList(['=', 'BETWEEN']);
      } else if (searchVal == "country") {
        setOperatorList(['=']);
        updateCountries()
          .then((data) => {
            const formattedCountryData = data.data.data.map(country => ({
              value: country.country_name,
              name: country.country_name
            }));
            setOptionsList(formattedCountryData);
          })
          .catch(err => console.log(err));
      } else if (searchVal == "language") {
        setOperatorList(['=']);
        updateLanguage()
          .then((data) => {  // Get the data directly from the API response
            const formattedformLanguages = data.data.data.map(language => ({
              value: language.id,
              name: language.name
            }));
            setOptionsList(formattedformLanguages);
            console.log(formattedformLanguages, "formattedformLanguages"); // This will show the actual data
          })
          .catch(err => console.log(err));
      } else if (searchVal == "timezone") {
        setOperatorList(['=']);
        updateTimeZone()
          .then((data) => {
            const formattedTimezoneData = data.data.data.map(timezone => ({
              value: timezone.id,
              name: timezone.front_name
            }));
            setOptionsList(formattedTimezoneData);
          })
          .catch(err => console.log(err));
      } else if (searchVal == "interview_status") {
        setOperatorList(['=']);
        setFilterOprater('=');
        setShowOprater(false);
        setOptionsList(pendingApprovalFilterOptions.interview_status);
      }
      else if (searchVal == "referralCode") {
        setOperatorList(['=', 'LIKE']);

      }
      else {
        setOperatorList(['=']);
      }
    }

    if (searchFilterOprater !== null) {
      setFilterOprater(searchFilterOprater)
      //
    }
    if (searchOprator !== null) {
      console.log(searchOprator, "searchOprator")
      if (searchOprator == "true") {
        setShowOprater(true);
      } else {
        setShowOprater(false);
      }

    }
    setTimeout(() => {
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("view");
      newUrl.searchParams.delete("search");
      newUrl.searchParams.delete("searchName");
      newUrl.searchParams.delete("searchFilterOprater");
      newUrl.searchParams.delete("searchOprator");
      newUrl.searchParams.delete("page");
      newUrl.searchParams.delete("rowperpage");
      newUrl.searchParams.delete("pagintion");

      setQueryValue(status)
      window.history.replaceState({}, document.title, newUrl.href);
    }, 2000)
    if ((location.pathname === "/mediums" && location.search === "") || (location.pathname === "/mediums" && location.search === "?view=allmediums")) {
      launcApi();
      // if (users.length === 0) {
      const data = {
        page: 1,
        rowsPerPage: 25,
        screen_name: searchValue !== undefined ? searchValue.screen_name !== undefined ? searchValue.screen_name : '' : '',
        email: searchValue !== undefined ? searchValue.email !== undefined ? searchValue.email : '' : '',
        created_at: searchValue !== undefined ? searchValue.created_at !== undefined ? searchValue.created_at : '' : '',

      }

      callUsers(data,1);
    }
    // }
    if (location.pathname === "/mediums" && location.search === "?view=0") {
console.log(backupmediums,"backupmediums,")
setAllMediums(backupmediums)
      // if (!backupmediums.length) { launcApi()  } else { setAllMediums(backupmediums);}
      // getPathFromUrl();
    }
    if (location.pathname === "/mediums" && location.search === "?view=1") {
      setAllNovice(backupnovice);
      console.log(backupnovice);
      // getPathFromUrl();
    }
    if (location.pathname === "/mediums" && location.search === "?view=2") {
      setAllIntermediate(backupintermediate);
      // getPathFromUrl();
    }
    if (location.pathname === "/mediums" && location.search === "?view=3") {
      console.log(allProfessionals, "backupprofessionals");
      setAllProfessionals(backupprofessionals);
    }
    if (location.pathname === "/mediums" && location.search === "?view=4") {
      console.log(backupPending, "backupPending");
      setUsers(backupPending);
    }
    if (location.pathname === "/mediums" && location.search === "?view=5") {
      setAllUnverifiedEmails(backupUnverfiedEmails);
      // getPathFromUrl();
    }
    if (status === "all" || status === "4") setActiveTab(4);
    if (status === "1") setActiveTab(1);
    if (status === "2") setActiveTab(2);
    if (status === "3") setActiveTab(3);
    if (status === "5") setActiveTab(5);
    if (status === "6") setActiveTab(6);
  }, []);
  const updateCountries = () => {
    return new Promise((resolve, reject) => {
      getCountry()
        .then((data) => {
          if (data.data.status) {
            setCountryData(data.data.data);
          }
          resolve(data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });

  };
  const updateTimeZone = () => {
    return new Promise((resolve, reject) => {
      getTimezones()
        .then((data) => {
          if (data.data.status) {
            setTimezoneData(filterVisibleTimeZones(data.data.data));
          }
          resolve(data); // Resolve the promise with the data
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  };
  const updateLanguage = () => {
    return new Promise((resolve, reject) => {
      getLanguages()
        .then((data) => {
          setFormLanguages(
            data.data.data.map((item) => {
              return {
                ...item,
                value: item.id,
                label: item.name,
              };
            })
          );
          resolve(data); // Resolve the promise after setting form languages
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  };
  function getPathFromUrl(url) {
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete("view");
    window.history.replaceState({}, document.title, newUrl.href);
  }
  const setListedArray = (item, set) => {
    const intermediates = item.map((resp) => {
      return {
        ...resp,
        status: false,
        resent_status: 0,
      };
    });

    set(intermediates);

    setListArray(
      list.map((item) => {
        if (item.name === "All Medium") {
          return {
            ...item,
            ...(item.count = allMediumCount),
          };
        }
        if (item.name === "Professional") {
          return {
            ...item,
            ...(item.count = allProfessionalsCount),
          };
        }

        if (item.name === "Pending Approvals") {
          return {
            ...item,
            ...(item.count = allPendingApprovalsCount),
          };
        }
        if (item.name === "Incomplete Registration") {
          return {
            ...item,
            ...(item.count = allUnverifiedEmailsCount),
          };
        }

        if (item.name === "Novice") {
          return {
            ...item,
            ...(item.count = allNoviceCount),
          };
        }
        if (item.name === "Intermediate") {
          return {
            ...item,
            ...(item.count = allIntermediateCount),
          };
        }
        if (item.name === "Declined") {
          return {
            ...item,
            ...(item.count = allDeclinedCount),
          };
        } else {
          return {
            ...item,
          };
        }
      })
    );
  };
  useEffect(() => {setListArraycaount() }, [allMediumCount, allProfessionalsCount, allNoviceCount, allIntermediateCount, allDeclinedCount, allPendingApprovalsCount, allUnverifiedEmailsCount]);
 const setListArraycaount =()=>{
  setListArray(
      list.map((item) => {
        if (item.name === "All Medium") {
          return {
            ...item,
            ...(item.count = allMediumCount),
          };
        }
        if (item.name === "Professional") {
          return {
            ...item,
            ...(item.count = allProfessionalsCount),
          };
        }

        if (item.name === "Pending Approvals") {
          return {
            ...item,
            ...(item.count = allPendingApprovalsCount),
          };
        }
        if (item.name === "Incomplete Registration") {
          return {
            ...item,
            ...(item.count = allUnverifiedEmailsCount),
          };
        }

        if (item.name === "Novice") {
          return {
            ...item,
            ...(item.count = allNoviceCount),
          };
        }
        if (item.name === "Intermediate") {
          return {
            ...item,
            ...(item.count = allIntermediateCount),
          };
        }
        if (item.name === "Declined") {
          return {
            ...item,
            ...(item.count = allDeclinedCount),
          };
        } else {
          return {
            ...item,
          };
        }
      })
    );
 } 
  useEffect(() => {
    setListedArray(allMediums, setMediums);
  }, [allMediums]);
  useEffect(() => {
    setListedArray(allProfessionals, setProfessionals);
  }, [allProfessionals]);
  useEffect(() => {
    setListedArray(allIntermediate, setIntermediate);
  }, [allIntermediate]);
  useEffect(() => {
    setListedArray(allNovice, setNovice);
  }, [allNovice]);
  useEffect(() => {
    setListedArray(users, setPendingApprovals);
  }, [users]);
  useEffect(() => {
    setListedArray(allunverifiedEmails, setUnverifiedEmails);
  }, [allunverifiedEmails]);
  useEffect(() => {
    setListedArray(allDeclined, setDeclinedMediums);
  }, [allDeclined]);

  // useEffect(() => {

  //   if (window.renderFirst) {



  //     const data = {
  //       page: 1,
  //       rowsPerPage: 10,
  //       screen_name: '',
  //       email: '',
  //       created_at: '',

  //     }
  //     if (activeTab === 0) {
  //       setFilterValues('screen_name')
  //       setSearchValues('')
  //       getAllNoviceList(data, 'tab');
  //       getAllIntermediateList(data, 'tab');
  //       getAllProfessionalsList(data, 'tab');
  //       getAllUnVerifiedEmails(data, 'tab');
  //       callUsers(data, 'tab');
  //       getAllDeclinedList(data, 'tab');

  //     }


  //     if (activeTab === 1) {
  //       setFilterValues('screen_name')
  //       setSearchValues('')

  //       getMediumList(data, 'tab');

  //       getAllIntermediateList(data, 'tab');
  //       getAllProfessionalsList(data, 'tab');
  //       getAllUnVerifiedEmails(data, 'tab');
  //       callUsers(data, 'tab');
  //       getAllDeclinedList(data, 'tab');

  //     }
  //     if (activeTab === 2) {
  //       setFilterValues('screen_name')
  //       setSearchValues('')

  //       getMediumList(data, 'tab');
  //       getAllNoviceList(data, 'tab');
  //       getAllProfessionalsList(data, 'tab');
  //       getAllUnVerifiedEmails(data, 'tab');
  //       callUsers(data, 'tab');
  //       getAllDeclinedList(data, 'tab');

  //     }
  //     if (activeTab === 3) {
  //       setFilterValues('screen_name')
  //       setSearchValues('')
  //       getMediumList(data, 'tab');
  //       getAllNoviceList(data, 'tab');
  //       getAllIntermediateList(data, 'tab');
  //       getAllUnVerifiedEmails(data, 'tab');
  //       callUsers(data, 'tab');
  //       getAllDeclinedList(data, 'tab');

  //     }
  //     if (activeTab === 4) {
  //       setFilterValues('screen_name')
  //       setSearchValues('')
  //       getMediumList(data, 'tab');
  //       getAllNoviceList(data, 'tab');
  //       getAllIntermediateList(data, 'tab');
  //       getAllProfessionalsList(data, 'tab');
  //       getAllUnVerifiedEmails(data, 'tab');
  //       getAllDeclinedList(data, 'tab');

  //     }
  //     if (activeTab === 6) {
  //       setFilterValues('screen_name')
  //       setSearchValues('')
  //       getMediumList(data, 'tab');
  //       getAllNoviceList(data, 'tab');
  //       getAllIntermediateList(data, 'tab');
  //       getAllProfessionalsList(data, 'tab');
  //       getAllUnVerifiedEmails(data, 'tab');
  //       callUsers(data, 'tab');


  //     }
  //     if (activeTab === 5) {
  //       setFilterValues('screen_name')
  //       setSearchValues('')
  //       getMediumList(data, 'tab');
  //       getAllNoviceList(data, 'tab');
  //       getAllIntermediateList(data, 'tab');
  //       getAllProfessionalsList(data, 'tab');
  //       callUsers(data, 'tab');
  //       getAllDeclinedList(data, 'tab');

  //     }


  //     // }
  //   } else {
  //     window.renderFirst = true;
  //   }
  // }, [activeTab]);

  const getMediumList = (item, info,firstCall=0) => {
    const payload = firstCall == 1
    ? { ...item, is_count: true }
    : item;
     return getAllMediums(payload)  // return the promise
    .then((res) => {
      if (res.data.status) {
      
       if(firstCall != 1){
        dispatch(setAllMediumsCountPage(res.data.data.total));
        dispatch(setAllMediums(res.data.data.data));
         dispatch(setAllMediumsCount(res.data.data.total));
          setbackupMediums(JSON.parse(JSON.stringify(res.data.data.data)));
       }else{
          dispatch(setAllMediumsCount(res.data.data));
       }
       
      }
      return res; // pass response for parent
    })
    .catch((err) => {
      console.error("Mediums API Error:", err);
      throw err; // propagate error for parent
    });
  };


  const getAllProfessionalsList = (data, info, firstCall=0) => {
    const payload = firstCall == 1
    ? { ...data, is_count: true }
    : data;
   
   return getAllProfessionals(payload) // return the axios promise
    .then((res) => {
      if (res.data.status) {
       
        if(firstCall != 1){
          dispatch(setAllProfessionalsCountPage(res.data.data.total));
            dispatch(setAllProfessionals(res.data.data.data));
             dispatch(setAllProfessionalsCount(res.data.data.total));
               setbackupProfessionals(JSON.parse(JSON.stringify(res.data.data.data)));
        }else{
           dispatch(setAllProfessionalsCount(res.data.data));
        }
      
      
      }
      return res; // pass response to parent
    })
    .catch((err) => {
      console.error("Professionals API Error:", err);
      throw err; // propagate error to parent
    });
  };
  const getAllNoviceList = (data, info, firstCall=0) => {
     const payload = firstCall == 1
    ? { ...data, is_count: true }
    : data;
  
    return getAllNovice(payload) // return the axios promise
    .then((res) => {
      if (res.data.status) {
        
        if(firstCall != 1){
          dispatch(setAllNoviceCount(res.data.data.total));
          dispatch(setAllNoviceCountPage(res.data.data.total));
          dispatch(setAllNovice(res.data.data.data));
          setbackupNovice(JSON.parse(JSON.stringify(res.data.data.data)));
        }else{
            dispatch(setAllNoviceCount(res.data.data));
        }

        
      }
      return res; // pass response to parent
    })
    .catch((err) => {
      console.error("Novice API Error:", err);
      throw err; // propagate error to parent
    });
  };
  const getAllIntermediateList = (data, info, firstCall=0) => {
    const payload = firstCall == 1
    ? { ...data, is_count: true }
    : data;
   
   return getAllIntermediate(payload) // return the axios promise
    .then((res) => {
      if (res.data.status) {
       
        if(firstCall != 1){
           dispatch(setAllIntermediateCount(res.data.data.total));
          dispatch(setAllIntermediateCountPage(res.data.data.total));
          dispatch(setAllIntermediate(res.data.data.data));
          setbackupIntermediate(JSON.parse(JSON.stringify(res.data.data.data)));
        }else{
            dispatch(setAllIntermediateCount(res.data.data));
        }
        
      }
      return res; // pass response to parent if needed
    })
    .catch((err) => {
      console.error("Intermediate API Error:", err);
      throw err; // rethrow so Promise.all / await catches it
    });
  };

  const getAllUnVerifiedEmails = async (data,info, firstCall=0) => {
    const payload = firstCall == 1
    ? { ...data, is_count: true }
    : data;
   
    const response = await getUnverfiedEmailsMediums(payload)
      .then((data) => {
       
        
        
        if(firstCall != 1){
          const update = data.data.data.data.map((resp) => {
          return {
            ...resp,
            status: false,
          };
        });
          dispatch(setAllUnverifiedEmailsCount(data.data.data.total))
          dispatch(setAllUnverifiedEmailsCountMediumPage(data.data.data.total));
          dispatch(setAllUnverifiedEmails(update));
           setbackupUnverifiedEmails(JSON.parse(JSON.stringify(data.data.data.data)));
        }else{
          dispatch(setAllUnverifiedEmailsCount(data.data.data))
        }
       
       
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });

    return response;
  };


  const getAllDeclinedList = (data, info , firstCall=0) => {
    
    const payload = firstCall == 1
    ? { ...data, is_count: true }
    : data;
    return getAllDeclinedMediums(payload) // return the axios promise
    .then((res) => {
      if (res.data.status) {
      
        dispatch(setAllDeclinedCount(res.data.data.total));
        dispatch(setAllDeclined(res.data.data.data));
        setbackupDeclined(JSON.parse(JSON.stringify(res.data.data.data)));
        
      }
      return res; // pass response to parent if needed
    })
    .catch((err) => {
      console.error("Declined Mediums API Error:", err);
      throw err; // rethrow so parent can handle it
    });
  };
 const launcApi = async () => {
  const data = {
  page: 1,
  rowsPerPage: 25,
  screen_name: searchValue && searchValue.screen_name ? searchValue.screen_name : '',
  email: searchValue && searchValue.email ? searchValue.email : '',
  created_at: searchValue && searchValue.created_at ? searchValue.created_at : '',
};


  try {
    //dispatch(setLoading(true));
    //setIsSearching(true);

    await Promise.all([
      getMediumList(data,undefined,1),
      getAllProfessionalsList(data,undefined,1),
      getAllIntermediateList(data,undefined,1),
      getAllDeclinedList(data,undefined,1),
      getAllUnVerifiedEmails(data,undefined,1),
      getAllNoviceList(data,undefined,1),
    ]);

  } catch (err) {
    console.error(err);
  //  setIsSearching(false);
  } finally {
    dispatch(setLoading(false));
    //setIsSearching(false);
  }
};

  const callUsers = async (data,firstCall=0) => {
     const payload = firstCall == 1
    ? { ...data, is_count: true }
    : data;
  
    // dispatch(setLoading(true));
    const response = await getUsers(payload)
      .then((data) => {
        // dispatch(setLoading(false));
        
        
        if(firstCall != 1){
          const update = data.data.data.data.map((resp) => {
          return {
            ...resp,
            status: false,
          };
        });
        console.log(data.data.data.total,"data.data.data.total");
          dispatch(setAllPendingApprovalsCount(data.data.data.total))
          dispatch(setAllPendingApprovalsCountPage(data.data.data.total));
          dispatch(setUsers(update));
           setbackupPending(JSON.parse(JSON.stringify(update)));
        }else{
    
          dispatch(setAllPendingApprovalsCount(data.data.data))
        }
       
      })
      .catch((err) => {
        // dispatch(setLoading(false));
        console.log(err);
      });

    return response;
  };

  const updateUser = async (user, status, name, item) => {
    if (name === "delete") {
      window.loadModal2("#deleteConfirmation", "show");
      let data = { user, status, name, item };
      setDeletInfo(data);
    } else {
      deleteUser(user, status, name, item);
    }
  };
  const deleteUser = async (user, status, name, item) => {
    let body = {
      user_id: status !== undefined ? user.id : deleteInfo.user.id,
      medium_status:
        status !== undefined
          ? user.medium_status
          : deleteInfo.user.medium_status,
      status: status !== undefined ? status : deleteInfo.status,
    };
    await approveUser(body)
      .then((data) => {
        if (data.data.status) {
          toast.success('Status Updated', { position: 'top-center' })
          const data = {
            page: 1,
            rowsPerPage: 25,
            screen_name: searchValue !== undefined ? searchValue.screen_name !== undefined ? searchValue.screen_name : '' : '',
            email: searchValue !== undefined ? searchValue.email !== undefined ? searchValue.email : '' : '',
            created_at: searchValue !== undefined ? searchValue.created_at !== undefined ? searchValue.created_at : '' : '',
          }
          getCount();
          getAllIntermediateList(data);
          getAllDeclinedList(data);
          getAllNoviceList(data);
          getAllProfessionalsList(data);
          getMediumList(data);
          getAllUnVerifiedEmails(data);
          callUsers();
        }
        // if (deleteInfo.name == "mediums" || deleteInfo.name == "delete")
        //   getMediumList();
        // if (deleteInfo.name == "intermediate" || deleteInfo.name == "delete")
        //   getAllIntermediateList();
        // if (deleteInfo.name == "novice" || deleteInfo.name == "delete")
        //   getAllNoviceList();
        // if (deleteInfo.name == "professional" || deleteInfo.name == "delete")
        //   getAllProfessionalsList();
        // if (deleteInfo.item == "pendingApprovals"|| item == "pendingApprovals")  callUsers();
      })
      .catch(() => { });
  };
  const getCount = async () => {
    await getAdminAppointmentCount()
      .then((data) => {
        // dispatch(setLoading(false));
        if (data.data.status) {
          dispatch(setDashboardCount(data.data.data));
        }
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };



  const getPaginationData = (data, activeTab) => {
setIsSearching(true);
    let keyVal = "";
    let searchVal = "";
    if (!searchValue || Object.keys(searchValue).length === 0) {
      keyVal = "";
      searchVal = "";
    } else {
      const [[keyData, valData]] = Object.entries(searchValue);
      keyVal = keyData != null && keyData != "orderBy" && keyData != "created_at_order_by" ? keyData : "";
      searchVal = valData != null && valData != "asc" && valData != "desc" ? valData : "";
    }

    let info = {
      ...data,
      screen_name: searchValue !== undefined ? searchValue.screen_name !== undefined ? searchValue.screen_name : '' : '',
      email: searchValue !== undefined ? searchValue.email !== undefined ? searchValue.email : '' : '',
      created_at: searchValue !== undefined ? searchValue.created_at !== undefined ? searchValue.created_at : '' : '',
      field: keyVal,
      value: searchVal,
      orderBy: ShortingBy,
      oprater: filterOprater ? filterOprater : "",
    }
   let apiPromise;

  if (activeTab === 0) {
    apiPromise = getMediumList(info);
  } else if (activeTab === 1) {
    apiPromise = getAllNoviceList(info);
  } else if (activeTab === 2) {
    apiPromise = getAllIntermediateList(info);
  } else if (activeTab === 3) {
    apiPromise = getAllProfessionalsList(info);
  } else if (activeTab === 4) {
    apiPromise = callUsers(info);
  } else if (activeTab === 5) {
    apiPromise = getAllUnVerifiedEmails(info);
  } else if (activeTab === 6) {
    apiPromise = getAllDeclinedList(info);
  }

  if (apiPromise) {
    apiPromise
      .then(() => {
        dispatch(setLoading(false)); // loader OFF after API completes
        setIsSearching(false);
      })
      .catch((err) => {
        console.error("Pagination API error:", err);
        dispatch(setLoading(false)); // loader OFF even if API fails
         setIsSearching(false);
      });
  } else {
    dispatch(setLoading(false)); // no API to call, turn loader OFF
  }
  };


  const onClickHandler = (e, id, name) => {
    e.stopPropagation();
    if (name === "mediums") {
      const response = mediums.map((user) => {
        if (user.id === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setMediums(response);
    }
    if (name === "intermediate") {
      const response = intermediate.map((user) => {
        if (user.id === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setIntermediate(response);
    }
    if (name === "novice") {
      const response = novice.map((user) => {
        if (user.id === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setNovice(response);
    }
    if (name === "professional") {
      const response = professionals.map((user) => {
        if (user.id === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setProfessionals(response);
    }
    if (name === "pendingAprrovals") {
      const response = pendingApprovals.map((user) => {
        if (user.id === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setPendingApprovals(response);
    }
    if (name === "unverifiedemails") {
      const response = unverifiedEmails.map((user) => {
        if (user.id === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setUnverifiedEmails(response);
    }
    if (name === "declined") {
      const response = declinedMediums.map((user) => {
        if (user.id === id) {
          user.status = !user.status;
        } else {
          user.status = false;
        }
        return user;
      });
      setDeclinedMediums(response);
    }
  };
  const updatePendingApprovalsFromFilter = (data) => {
    if (data.data.status) {
      dispatch(setAllPendingApprovalsCount(data.data.data.total));
      dispatch(setAllPendingApprovalsCountPage(data.data.data.total));
      dispatch(setUsers(data.data.data.data));
      dispatch(setPendingApprovalsPage(pendingapprovalsPage + 1));
      dispatch(setPendingApprovalsrowsPerPage(globalRowsPerPage));
      setbackupPending(JSON.parse(JSON.stringify(data.data.data.data)));
    }
  };

  const filterListMediums = (constants, opraterVal) => {
    setIsSearching(true);
    let keyVal = "";
    let searchVal = "";
    if (!searchValue || Object.keys(searchValue).length === 0) {
      keyVal = "";
      searchVal = "";
    } else {
      const [[keyData, valData]] = Object.entries(searchValue);
      keyVal = keyData != null && keyData != "orderBy" && key != "created_at_order_by" ? keyData : "";
      searchVal = valData != null && valData != "asc" && valData != "desc" ? valData : "";
    }
    const [[key, val]] = Object.entries(constants);
    if (key == "created_at_order_by" || key == "orderBy") {
      keyVal = keyVal;
      searchVal = searchVal;
    } else {
      keyVal = key;
      searchVal = val;
    }
    
    const { email, screen_name, created_at, orderBy = "asc" } = constants;
    setshortingBy(orderBy);
    let body = {
      email,
      screen_name,
      created_at,
      orderBy,
      field: keyVal,
      value: searchVal,
      oprater: opraterVal ? opraterVal : filterOprater,
    };
    if (keyVal === "interview_status") {
      filterAllPendingApprovals(body)
        .then(updatePendingApprovalsFromFilter)
        .finally(() => {
          setIsSearching(false);
        });
      return;
    }

    // if (parseInt(activeTab) === 0) {
     const promises = [
    filterAllmediums(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(setAllMediumsCount(data.data.data.total))
          dispatch(setAllMediumsCountPage(data.data.data.total) )
          dispatch(setAllMediums(data.data.data.data));
          dispatch(setMediumPage(mediumpage + 1));
          dispatch(setMediumrowsPerPage(globalRowsPerPage));
          setbackupMediums(JSON.parse(JSON.stringify(data.data.data.data)));
        }
      }),

    // }

    // if (parseInt(activeTab) === 1) {
    filterAllNovice(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(setAllNoviceCount(data.data.data.total))
            dispatch(setAllNoviceCountPage(data.data.data.total));
          dispatch(setAllNovice(data.data.data.data));
          dispatch(setNovicePage(novicepage + 1));
          dispatch(setNovicerowsPerPage(globalRowsPerPage));
          setbackupNovice(JSON.parse(JSON.stringify(data.data.data.data)));
        }
      }),
 
    // }
    // if (parseInt(activeTab) === 2) {
    filterAllIntermediate(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(setAllIntermediateCount(data.data.data.total))
          dispatch(setAllIntermediateCountPage(data.data.data.total));
          dispatch(setAllIntermediate(data.data.data.data));
          dispatch(setIntermediatePage(intermediatePage + 1));
          dispatch(setIntermediaterowsPerPage(globalRowsPerPage));
          setbackupIntermediate(JSON.parse(JSON.stringify(data.data.data.data)));
        }
      }),

    // }
    // if (parseInt(activeTab) === 3) {
    filterAllProfessionals(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(setAllProfessionalsCount(data.data.data.total))
          dispatch(setAllProfessionalsCountPage(data.data.data.total));
          dispatch(setAllProfessionals(data.data.data.data));
          dispatch(setProfessionalPage(professionalPage + 1));
          dispatch(setProfessionalrowsPerPage(globalRowsPerPage));
          setbackupProfessionals(JSON.parse(JSON.stringify(data.data.data.data)));
        }
      }),
 
    // }
    // if (parseInt(activeTab) === 4) {
    filterAllPendingApprovals(body)
      .then(updatePendingApprovalsFromFilter),

    // }
    // if (parseInt(activeTab) === 5) {
    filterAllUnverifiedEmails(body)
      .then((data) => {
        if (data.data.status) {
          dispatch(setAllUnverifiedEmailsCount(data.data.data.total))
          dispatch(setAllUnverifiedEmailsCountMediumPage(data.data.data.total))
          dispatch(setAllUnverifiedEmails(data.data.data.data));
          dispatch(setUnverifiedEmailsPage(unverifiedEmailsPage + 1));
          dispatch(setUnverifiedEmailsrowsPerPage(globalRowsPerPage));
          setbackupUnverifiedEmails(JSON.parse(JSON.stringify(data.data.data.data)));
        }
      })
  
      ];
       Promise.allSettled(promises).finally(() => {
    setIsSearching(false);
  });
    // }
  };
  const bulkActions = (status, selected) => {
    let body = { status, selected };
    setBulkInfo(body);
    if (parseInt(status) === 3) {
      window.loadModal2("#deleteConfirmation1", "show");
    } else {
      bulkActionsHanlder(body);
    }
  };
  const bulkActionsHanlder = (info) => {
    let body;
    if (bulkInfo.status !== undefined) {
      body = {
        status: bulkInfo.status,
        users: bulkInfo.selected,
      };
    } else {
      body = {
        status: info.status,
        users: info.selected,
      };
    }
    performBulkActions(body)
      .then((data) => {
        console.log(data.data.status, "status"
        )
        if (data.data.status) {
          let keyVal = "";
          let searchVal = "";
          if (!searchValue || Object.keys(searchValue).length === 0) {
            keyVal = "";
            searchVal = "";
          } else {
            const [[keyData, valData]] = Object.entries(searchValue);
            keyVal = keyData != null && keyData != "orderBy" && keyData != "created_at_order_by" ? keyData : "";
            searchVal = valData != null && valData != "asc" && valData != "desc" ? valData : "";
          }

          let info = {
            page: 1,
            rowsPerPage: 25,
            screen_name: searchValue !== undefined ? searchValue.screen_name !== undefined ? searchValue.screen_name : '' : '',
            email: searchValue !== undefined ? searchValue.email !== undefined ? searchValue.email : '' : '',
            created_at: searchValue !== undefined ? searchValue.created_at !== undefined ? searchValue.created_at : '' : '',
            field: keyVal,
            value: searchVal,
            oprater: filterOprater ? filterOprater : "",
          }
          getMediumList(info);
          getAllProfessionalsList(info);
          getAllDeclinedList(info);
          getAllIntermediateList(info);
          getAllNoviceList(info);
          getAllUnVerifiedEmails(info);
          callUsers(info);
          toast.success('Status Updated', { position: 'top-center' })

        }
      })
      .catch(() => { });
  };
  const resendUnverifiedEmail = (e, id) => {
    e.stopPropagation();
    resendActivationUnverifiedMail(id, "unverified")
      .then((data) => {
        if (data.data.status) {
          let response = unverifiedEmails.map((item) => {
            if (parseInt(item.id) === parseInt(id)) {
              return {
                ...item,
                ...(item.resent_status = 1),
              };
            } else {
              return { ...item };
            }
          });
          setUnverifiedEmails(response);
        }
        if (!data.data.status) {
          let response = unverifiedEmails.map((item) => {
            if (parseInt(item.id) === parseInt(id)) {
              return {
                ...item,
                ...(item.resent_status = 2),
              };
            } else {
              return { ...item };
            }
          });
          setUnverifiedEmails(response);
        }
      })
      .catch(() => { });

    setTimeout(() => {
      let response = unverifiedEmails.map((item) => {
        return {
          ...item,
          ...(item.resent_status = 0),
        };
      });
      setUnverifiedEmails(response);
    }, 6000);
  };

  const resendEmail = (e, id) => {
    e.stopPropagation();
    resendActivationMail(id)
      .then((data) => {
        if (data.data.status) {
          let response = pendingApprovals.map((item) => {
            if (parseInt(item.id) === parseInt(id)) {
              return {
                ...item,
                ...(item.resent_status = 1),
              };
            } else {
              return { ...item };
            }
          });
          setPendingApprovals(response);
        }
        if (!data.data.status) {
          let response = pendingApprovals.map((item) => {
            if (parseInt(item.id) === parseInt(id)) {
              return {
                ...item,
                ...(item.resent_status = 2),
              };
            } else {
              return { ...item };
            }
          });
          setPendingApprovals(response);
        }
      })
      .catch(() => { });

    setTimeout(() => {
      let response = pendingApprovals.map((item) => {
        return {
          ...item,
          ...(item.resent_status = 0),
        };
      });
      setPendingApprovals(response);
    }, 6000);
  };
  const cancelRequest = () => {
    setDeletInfo({});
    setBulkInfo({});
  };
  // ── Filter section helpers (tab-aware) ──────────────────────────────────
  const getTabFilterList = () => (activeTab === 4 ? filterListpendin : filterList);

  const getTabBulkList = () => {
    if (activeTab === 6) return bulkListDeclined;   // Approve + Delete
    if (activeTab === 4 || activeTab === 5) return []; // commented-out in originals
    return bulkList;                                 // Delete only
  };

  const getTabExportType = () => {
    const types = ["all", "novice", "intermediate", "professional", "pending", "unverified", "declined"];
    return types[activeTab] !== undefined ? types[activeTab] : "all";
  };

  const handleRecalculateSlots = () => {
    setIsRecalculating(true);
    regenerateAllMediumSlots()
      .then((data) => {
        if (data && data.data && data.data.status) {
          toast.success(data.data.message, { position: "top-center" });
        } else {
          toast.error((data && data.data && data.data.message) || "Slot recalculation request failed", { position: "top-center" });
        }
      })
      .catch(() => {
        toast.error("Slot recalculation request failed", { position: "top-center" });
      })
      .finally(() => {
        setIsRecalculating(false);
      });
  };

  const handleExport = () => {
    return exportMediumList({
      user_type: getTabExportType(),
      field: searchValue && Object.keys(searchValue).length ? filterValues : "",
      value: Object.values(searchValue) || "",
      oprater: searchValue && Object.keys(searchValue).length ? filterOprater : "",
    })
      .then((data) => {
        if (data && data.data && data.data.status) {
          toast.success(data.data.message, { position: "top-center" });
        } else {
          toast.error((data && data.data && data.data.message) || "Export request failed", { position: "top-center" });
        }
      })
      .catch(() => {});
  };

  const changeHandler = (e) => {
    if (e.target.value === "Approve") bulkActions(1, selected);
    if (e.target.value === "Decline") bulkActions(2, selected);
    if (e.target.value === "Delete")  bulkActions(3, selected);
  };
  // ────────────────────────────────────────────────────────────────────────

  const filterReset = () => {
    setFilterValues('screen_name');
    setSearchValues("");
    let dataVal = {
      "email": "",
      "client_name": "",
      "created_at": "",
      "orderBy": "desc",
      "referal_code": "",
      "created_at_order_by": ""
    }
    filterListMediums(dataVal);
  }
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
    setSelected([]);
    setChecked(false);
    if (filterValues === "interview_status" && tabIndex !== 4) {
      setFilterValues("screen_name");
      setSearchValues("");
      setOperatorList(["=", "LIKE"]);
      setFilterOprater("LIKE");
      setShowOprater(true);
    }
  };

  return (
    <div className="all-medium-page medium-tab-pad">
      {/* ── Export button — top right ── */}
      <div className="export-top-row" style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginBottom: "10px" }}>
        <button
          className="recalculate-slots-btn"
          type="button"
          onClick={handleRecalculateSlots}
          disabled={isRecalculating}
        >
          {isRecalculating ? "Recalculating..." : "Recalculate Slots"}
        </button>
        <CsvDownload onClick={handleExport} />
      </div>

      {/* ── Filter section — sits above the tabs ── */}
      <div className="d-flex justify-content-end gap-10 flex-wrap bottomClass">
        {activeTab !== 6 && (
          <>
            <Search
              callApi={() => {}}
              list={getTabFilterList()}
              searchValue={searchValue}
              setSearchValues={setSearchValues}
              setFilterValues={setFilterValues}
              filterValues={filterValues}
              isDatepickerShow={1}
              setOptionsList={setOptionsList}
              optionsList={optionsList}
              operatorList={operatorList}
              setOperatorList={setOperatorList}
              showOprater={showOprater}
              setShowOprater={setShowOprater}
              setFilterOprater={setFilterOprater}
              filterOprater={filterOprater}
              setFilterValueOptions={setFilterValueOptions}
              filterValueOptions={filterValueOptions}
              filterOptions={pendingApprovalFilterOptions}
              isOperator={1}
              callNewApi={filterListMediums}
              isSearchBtn={1}
            />
            <Button
              status={0}
              type="button"
              onClick={filterReset}
              className="resend-btn width-100px reset-btn-123"
              title="Load All"
            />
          </>
        )}
        {getTabBulkList().length > 0 && selected.length > 0 && (
          <Filter
            name={"Bulk Actions"}
            list={getTabBulkList()}
            changeHandler={changeHandler}
          />
        )}
      </div>

      <Tabs active={activeTab} list={listArray} setActiveTab={handleTabChange} />
      <ul className="tabs-content">
        <TabPanel id={0} activeTab={activeTab}>
          <Medium
            mediums={mediums}
            updateUser={updateUser}
            filterReset={filterReset}
            onClickHandler={onClickHandler}
            filterListMediums={filterListMediums}
            activeTab={activeTab}
            bulkActions={bulkActions}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            getMediumList={getMediumList}
            mediumpage={mediumpage}
            mediumrowsPerPage={mediumrowsPerPage}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            isSearching={isSearching}
            selected={selected}
            setSelected={setSelected}
            checked={checked}
            setChecked={setChecked}
          />
        </TabPanel>
        <TabPanel id={1} activeTab={activeTab}>
          <Novice
            novices={novice}
            updateUser={updateUser}
            onClickHandler={onClickHandler}
            filterListMediums={filterListMediums}
            filterReset={filterReset}
            bulkActions={bulkActions}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            novicepage={novicepage}
            novicerowsPerPage={novicerowsPerPage}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            isSearching={isSearching}
            selected={selected}
            setSelected={setSelected}
            checked={checked}
            setChecked={setChecked}
          />
        </TabPanel>
        <TabPanel id={2} activeTab={activeTab}>
          <Intermediate
            intermediates={intermediate}
            updateUser={updateUser}
            onClickHandler={onClickHandler}
            filterListMediums={filterListMediums}
            bulkActions={bulkActions}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            intermediatePage={intermediatePage}
            intermediaterowsPerPage={intermediaterowsPerPage}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            isSearching={isSearching}
            selected={selected}
            setSelected={setSelected}
            checked={checked}
            setChecked={setChecked}
          />
        </TabPanel>
        <TabPanel id={3} activeTab={activeTab}>
          <Professional
            professionals={professionals}
            updateUser={updateUser}
            onClickHandler={onClickHandler}
            filterListMediums={filterListMediums}
            bulkActions={bulkActions}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            professionalPage={professionalPage}
            professionalrowsPerPage={professionalrowsPerPage}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            isSearching={isSearching}
            selected={selected}
            setSelected={setSelected}
            checked={checked}
            setChecked={setChecked}
          />
        </TabPanel>

        <TabPanel id={4} activeTab={activeTab}>
          <PendingApprovals
            updateUser={updateUser}
            pendingApprovals={pendingApprovals}
            setPendingApprovals={setPendingApprovals}
            onClickHandler={onClickHandler}
            bulkActions={bulkActions}
            resendEmail={resendEmail}
            filterListMediums={filterListMediums}
            filterReset={filterReset}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            pendingapprovalsPage={pendingapprovalsPage}
            pendingapprovalsrowsPerPage={pendingapprovalsrowsPerPage}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            isSearching={isSearching}
            selected={selected}
            setSelected={setSelected}
            checked={checked}
            setChecked={setChecked}
          />
        </TabPanel>

        <TabPanel id={5} activeTab={activeTab}>
          <UnverifiedEmails
            updateUser={updateUser}
            unverifiedEmails={unverifiedEmails}
            onClickHandler={onClickHandler}
            filterReset={filterReset}
            resendUnverifiedEmail={resendUnverifiedEmail}
            filterListMediums={filterListMediums}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            unverifiedEmailsPage={unverifiedEmailsPage}
            unverifiedEmailsrowsPerPage={unverifiedEmailsrowsPerPage}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            isSearching={isSearching}
            selected={selected}
            setSelected={setSelected}
            checked={checked}
            setChecked={setChecked}
          />
        </TabPanel>
        <TabPanel id={6} activeTab={activeTab}>
          <Declined
            updateUser={updateUser}
            pendingApprovals={declinedMediums}
            onClickHandler={onClickHandler}
            filterReset={filterReset}
            bulkActions={bulkActions}
            getPaginationData={(data) => getPaginationData(data, activeTab)}
            declinedPage={declinedPage}
            declinedrowsPerPage={declinedrowsPerPage}
            setFilterValues={setFilterValues}
            setSearchValues={setSearchValues}
            searchValue={searchValue}
            filterValues={filterValues}
            setOptionsList={setOptionsList}
            optionsList={optionsList}
            operatorList={operatorList}
            setOperatorList={setOperatorList}
            showOprater={showOprater}
            setShowOprater={setShowOprater}
            setFilterOprater={setFilterOprater}
            filterOprater={filterOprater}
            setFilterValueOptions={setFilterValueOptions}
            filterValueOptions={filterValueOptions}
            isSearching={isSearching}
            selected={selected}
            setSelected={setSelected}
            checked={checked}
            setChecked={setChecked}
          />
        </TabPanel>
      </ul>
      <ConfirmDelete
        cancelRequest={cancelRequest}
        deleteUser={deleteUser}
        id="deleteConfirmation"
      />
      <ConfirmDelete
        cancelRequest={cancelRequest}
        deleteUser={bulkActionsHanlder}
        id="deleteConfirmation1"
      />
      {/* <Pagination  rowsPerPageOptions={[5, 10, 25]}  count={100} getPaginationData={getPaginationData} /> */}
    </div>
  );
}
